// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPayorResult {
    static getAttributeTypeMap() {
        return MedicalEligibilityPayorResult.attributeTypeMap;
    }
}
MedicalEligibilityPayorResult.discriminator = undefined;
MedicalEligibilityPayorResult.additionalProperties = false;
MedicalEligibilityPayorResult.attributeTypeMap = [
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "insurancePolicyNumber",
        "baseName": "insurancePolicyNumber",
        "type": "string"
    },
    {
        "name": "patientRelation",
        "baseName": "patientRelation",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "plan",
        "baseName": "plan",
        "type": "MedicalEligibilityPlan"
    },
    {
        "name": "priorIdentifierNumber",
        "baseName": "priorIdentifierNumber",
        "type": "string"
    },
    {
        "name": "referenceId",
        "baseName": "referenceId",
        "type": "string"
    },
    {
        "name": "secondaryInsurance",
        "baseName": "secondaryInsurance",
        "type": "MedicalEligibilitySecondaryInsurance"
    },
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPayorResult.js.map